'use-strict';



var navControl = {
    navTop: null,
    selector: '',

    init: function() {
        let text = $('.js-translations .js-close').html();
        this.$subClose = $('<li class="close-link  icon  -close  js-close"><span>' + text + '</span></li>');

        if(isMobile()) {
            this.$mobileNav = $('.main-nav-mobile');

            var subMenuTitle = $('.js-translations .js-categories').html();
            $('.primary-menu > .menu-item-has-children', this.$mobileNav).prepend('<p class="submenu-title">'+ subMenuTitle +'</p>');

            this.navTop = $('.site-header-inner').offset().top;
            this.selector = '.site-header-inner';
        }
        else {
            this.navTop = $('.main-nav-desk .main-navigation').offset().top;
            this.selector = '.main-nav-desk .main-navigation';
        }

        $('.main-nav-desk  .sub-menu .sub-menu').append(this.$subClose);

        this.stickyNav(this.navTop, this.selector);
        this.events();
        //this.windowEvent();
    },

    events: function() {
        $(window).scroll(function() {
            this.stickyNav(this.navTop, this.selector);
        }.bind(this));

        if(isMobile()) {
            $('.menu-link a', this.$mobileNav).on('click', function() {
                this.$mobileNav.addClass('is-open');
            }.bind(this));

            $('.menu-close', this.$mobileNav).on('click', function() {
                this.$mobileNav.removeClass('is-open');
            }.bind(this));
        }

        $('.js-menu-switch').on('click', function(e) {
            e.preventDefault();

            if (!$(this).hasClass('active')) {
                const menu = $(this).attr('data-menu');
                $('.js-menu-item').addClass('hidden');
                $('.js-menu-item[data-menu="' + menu + '"]').removeClass('hidden');
                $('.js-menu-switch.active').removeClass('active');
                $(this).addClass('active');
            }
        });

        $('.main-nav-desk  .sub-menu .menu-item-has-children a, .main-nav-desk .search-bar a').on('click', function(e) {
            $(this).blur();
            $(this).parent().addClass('active');
            $('.main-nav-desk').addClass('is-inactive');
            $('input', $(this).parent()).focus();
            console.log($('input', $(this).parent()));
        });

        $('.main-nav-desk  .sub-menu .sub-menu .js-close, .main-nav-desk .search-bar .js-close').on('click', function(e) {
            $('.main-nav-desk .sub-menu .menu-item-has-children.active, .main-nav-desk .search-bar .active').removeClass('active');
            $('.main-nav-desk').removeClass('is-inactive');
        });
    },

    windowEvent: function() {
        $(window).on('resize', function() {
            this.eventsOff();
            this.init();
        }.bind(this));
    },

    eventsOff: function() {
        $('.main-nav-desk  .sub-menu .menu-item-has-children a').off('click');
        $('.main-nav-desk  .sub-menu .sub-menu .js-close').off('click');
        $('.js-menu-switch').off('click');
        $('.menu-close', this.$mobileNav).off('click');
        $('.menu-link a', this.$mobileNav).off('click');
    },

    stickyNav: function(elTop, selector) {
        let scrollTop = $(window).scrollTop();
        let el = $(selector);

        if(scrollTop > elTop) {
            el.addClass('sticky');
            el.parent().css('height', el.outerHeight());
        }
        else {
            el.removeClass('sticky');
            el.parent().css('height', '');
        }
    },
};



$(function() {

    navControl.init();

});